var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { sm: "6" } },
            [_c("admin-breadcrumb", { attrs: { name: "Users" } })],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "text-right align-self-end", attrs: { sm: "6" } },
            [
              _c(
                "no-permission-wrapper",
                { attrs: { show: !_vm.canCreateUsers } },
                [
                  _c(
                    "b-btn",
                    {
                      staticClass: "mb-4",
                      attrs: {
                        variant: "success",
                        disabled: !_vm.canCreateUsers,
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.openNewUserModal.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("Add New User")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: {
                    title: "Users",
                    "sub-title": "Manage all users registered in GreenLists",
                    "with-footer": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header-right",
                      fn: function () {
                        return [
                          _c("admin-companies-autocomplete", {
                            model: {
                              value: _vm.filters.company,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "company", $$v)
                              },
                              expression: "filters.company",
                            },
                          }),
                          _vm._v(" "),
                          _c("b-form-select", {
                            staticClass: "w-auto ml-2",
                            attrs: { options: _vm.statusOptions },
                            on: { change: () => _vm.loadUsers() },
                            model: {
                              value: _vm.filters.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "status", $$v)
                              },
                              expression: "filters.status",
                            },
                          }),
                          _vm._v(" "),
                          _c("b-form-select", {
                            staticClass: "w-auto ml-2",
                            attrs: { options: _vm.roleOptions },
                            on: { change: () => _vm.loadUsers() },
                            model: {
                              value: _vm.filters.role,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "role", $$v)
                              },
                              expression: "filters.role",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c("b-pagination", {
                            staticClass: "admin-pagination mb-0",
                            attrs: {
                              "total-rows": _vm.total_in_pages,
                              "per-page": _vm.per_page,
                              align: "center",
                            },
                            on: { change: _vm.loadUsers },
                            model: {
                              value: _vm.page,
                              callback: function ($$v) {
                                _vm.page = $$v
                              },
                              expression: "page",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("admin-users-table", {
                    attrs: {
                      users: _vm.users,
                      "sort-by": _vm.sortBy,
                      "sort-desc": _vm.sortDesc,
                    },
                    on: { "sort-changed": _vm.onSortChanged },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("admin-new-user-modal", {
        ref: "newUserModal",
        attrs: { "skip-admin-role": !_vm.canCreateAdmins },
        on: { created: _vm.newUserCreated },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }